export enum FilterUXVariant {
    HIDE_CATEGORY_SIBLINGS = "hide_category_siblings",
    OTHER_BUTTON_AVAILABLE = "other_button_available",
}
